export default __webpack_public_path__ + "static/media/20210819182538.7a030262.png";